<template>
    <div class="my-progress">
        <div class="progress-containter" :style="{'width': myWidth+'px', 'height': myHeight+'px'}">
            <div class="progress-inner" :style="{'width': widthData+'%', 'height': myHeight+'px', 
            'background': 'linear-gradient('+progressColor+',#403e3e, '+progressColor+')'}">
                <div class="progress-text" v-if="Number(widthData) >= 70">{{judgeValue(widthData)}}</div>
            </div>
            <div class="progress-container-text">
                <span v-if="Number(widthData) < 70">{{judgeValue(widthData)}}</span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    data() {
        return {
            // proressWidth: 30,
            usedAsset: '',
            remainAsset: '',
        }
    },
    props: {
        'proressWidth': '',
        'myWidth': Number,
        'myHeight': Number,
        'typeNum': Number,
    },
    computed: {
        widthData: function () {
            if (typeof this.proressWidth !== 'undefined') {
                var width_list = this.proressWidth.split(' : ');
                this.usedAsset = Number(width_list[0]);
                this.remainAsset = Number(width_list[2]);
                if (this.remainAsset == 0) return 0;
                var persentage = this.usedAsset / this.remainAsset *100;
                return persentage.toFixed(2);
            } 
        },

        // 进度条颜色显示判断
        progressColor: function () {
            // console.log(this.typeNum)
            if (typeof this.proressWidth !== 'undefined') {
                if (this.typeNum == 1) {
                    var width_list = this.proressWidth.split(' : ');
                    this.usedAsset = Number(width_list[0]);
                    this.remainAsset = Number(width_list[2]);
                    if (this.remainAsset == 0) return 0;
                    var persentage = this.usedAsset / this.remainAsset *100;
                    if (persentage >= 60) {
                        return '#ad2828';
                    } else {
                        return '#9dd026';
                    }
                } else {
                    return '##2A2D2E'
                }
            }
        }
    },
    methods: {
        judgeValue(data) {
            if (String(data) == '0.00') return '';
            else if (String(data) == '0') return '';
            return data+'%';
        },
    }
}
</script>

<style lang="scss" scoped>
    .my-progress{
        margin-right: 3px;
        .progress-containter{
            // border: 1px solid #5a6361;
            height: 18px;
            width: 110px;
            display: flex;
            justify-content: flex-start;
            background-color: #3e403f;
            .progress-container-text{
                font-size: 14px;
                line-height: 18px;
                margin-left: 2px;
                color: #fff;
            }
            .progress-inner{
                // border: 1px solid #969292;
                height: 18px;
                background: linear-gradient(#878a89,#403e3e, #878a89);
                // background-color: #878a89;
                background-repeat: no-repeat;
                background-size: 0;
                animation: move 4s ease both;
                .progress-text{
                    font-size: 14px;
                    line-height: 18px;
                    color: #fff;
                    text-align: right !important;
                }
            }
            @keyframes move {
                100%{
                    background-size: 100%;
                }
            }
        }
    }

    @media screen and (max-width: 800px) {
        .my-progress{
            .progress-containter{
                width: 100px;
                // height: 14px;
            }
        }
    }
    @media screen and (max-width: 420px) {
        .my-progress{
            // display: none;
            .progress-containter{
                width: 80px;
                height: 14px;
                .progress-inner{
                    height: 14px;
                }
                .progress-container-text{
                    font-size: 12px;
                    line-height: 14px;
                }
            }
        }
    }
</style>